import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'react-native';

import Image from '../Image';

import TrackableOnPress from './TrackableOnPress';
import './MajorLink.module.scss';

/**
 * Displays an icon-and-image link for the sidebar which tracks clicks and supports internal
 * navigation
 */
const MajorLink = ({
  trackingKey,
  route,
  params,
  onPress,
  imageWidth,
  imageHeight,
  image,
  children,
  linkTo,
  className,
}) => {
  const handlePress = e => {
    if (route) {
      linkTo(route, params);
    }

    if (typeof onPress === 'function') {
      onPress(e);
    }
  };

  return (
    <TrackableOnPress onPress={handlePress} trackingKey={trackingKey} className={className} styleName="link">
      {image ? <Image source={image} style={{ height: imageHeight, width: imageWidth }} /> : null}
      {typeof children === 'string' ? <Text styleName="link-text">{children}</Text> : <React.Fragment>{children}</React.Fragment>}
    </TrackableOnPress>
  );
};

MajorLink.propTypes = {
  /** ID to use in tracking calls */
  trackingKey: PropTypes.string.isRequired,
  /** A route string for navigation */
  route: PropTypes.string,
  /** Route params for navigation */
  params: PropTypes.object,
  /** Width of the icon image */
  imageWidth: PropTypes.number,
  /** Height of the icon image */
  imageHeight: PropTypes.number,
  /** An icon image to render */
  image: PropTypes.any,
  /** Called when the link is clicked */
  onPress: PropTypes.func,
  /** Component(s) to render within the link */
  children: PropTypes.node,
  /** Handles navigation. Called with a route name and optional params */
  linkTo: PropTypes.func,
  /** Class name to pass to children */
  className: PropTypes.string,
};

MajorLink.defaultProps = {
  onPress: null,
  children: null,
  route: null,
  params: {},
  imageWidth: 22,
  imageHeight: 22,
  image: null,
  linkTo: null,
  className: null,
};

export default MajorLink;
